module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-Bold_V1000.d7370df1.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/spirit/DaciaSpirit-Bold_V1000.eot
// module id = 657
// module chunks = 0